module.exports = __webpack_public_path__ + "img/syncpoupPost.b579fca2.png";